<template>
  <b-row>
    <b-col cols="12">
      <event-type-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventTypeContent from './EventTypeContent.vue'

export default {
  components: {
    BRow,
    BCol,

    EventTypeContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>